import { useEffect } from 'react';
import Highcharts from 'highcharts';
import Tree from 'highcharts/modules/treemap';
import exporting from 'highcharts/modules/exporting';
import data from 'highcharts/modules/data';
import Heatmap from 'highcharts/modules/heatmap';

Tree(Highcharts);
data(Highcharts);
Heatmap(Highcharts);
exporting(Highcharts);

const JobFollowersIndustry = () => {
  const initialChart = () => {
    Highcharts.chart('industry', {
      chart: {
        type: 'pie',
      },
      title: {
        text: 'Followers by Industry',
      },

      accessibility: {
        announceNewData: {
          enabled: true,
        },
        point: {
          valueSuffix: '%',
        },
      },

      credits: {
        enabled: false,
      },

      colors: ['#2d76a0', '#2779b8', '#4ca0cd', '#99c9e2'],

      plotOptions: {
        pie: {
          showInLegend: true,
        },
        series: {
          enableMouseTracking: false,
          dataLabels: {
            enabled: true,
            format: '{point.name}: {point.y:.1f}%',
          },
        },
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
      },

      series: [
        {
          name: '',
          colorByPoint: true,
          data: [
            {
              name: 'Other',
              y: 8,
            },
            {
              name: 'PR Agent',
              y: 7,
            },
            {
              name: 'Recruiter',
              y: 60,
            },
            {
              name: 'Sales Associate',
              y: 27,
            },
          ],
        },
      ],
    });
  };

  useEffect(() => {
    initialChart();
  }, []);

  return <div id="industry" />;
};

export default JobFollowersIndustry;
